import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    }, {
      path: '/',
      component: resolve => require(['../components/common/home.vue'], resolve),
      meta: { title: '导航菜单' },
      children: [
        {
          path: '/dashboard',
          component: resolve => require(['../components/pages/dashboard'], resolve),
          meta: { title: '系统首页' }
        }, {
          path: '/abnormal',
          component: resolve => require(['../components/pages/dashboardIndex/abnormal'], resolve),
          meta: { title: '异常提醒' }
        }, {
          path: '/agent',
          component: resolve => require(['../components/pages/index/agent'], resolve),
          meta: { title: '统计汇总' }
        }, {
          path: '/deviceAutho',
          component: resolve => require(['../components/pages/deviceManagement/deviceAutho'], resolve),
          meta: { title: '设备授权' }
        }, {
          path: '/deviceDetails',
          component: resolve => require(['../components/pages/deviceManagement/deviceDetails'], resolve),
          meta: { title: '设备授权详情' }
        }, {
          path: '/cabinetMange',
          redirect: '/cabinetRegister',
          component: resolve => require(['../components/pages/deviceManagement/cabinetMange'], resolve),
          meta: { title: '柜机管理' },
          children: [
            {                                     //三级路由
              path: '/cabinetRegister',
              name: '/cabinetRegister',
              meta: { title: '柜机注册' },
              component: resolve => require(['../components/pages/deviceManagement/cabinetRegister'], resolve),
            }, {                                     //三级路由
              path: '/registerDetails',
              name: '/registerDetails',
              meta: { title: '注册详情' },
              component: resolve => require(['../components/pages/deviceManagement/registerDetails'], resolve),
            }, {                                     //三级路由
              path: '/cabinetDispose',
              name: '/cabinetDispose',
              meta: { title: '柜机配置' },
              component: resolve => require(['../components/pages/deviceManagement/cabinetDispose'], resolve),
            }, {
              path: '/lockDetails',
              name: 'lockDetails',
              meta: { title: '格口锁定详情' },
              component: resolve => require(['../components/pages/deviceManagement/lockDetails'], resolve),
            }, {
              path: '/latticeList',
              name: 'latticeList',
              meta: { title: '格口操作' },
              component: resolve => require(['../components/pages/deviceManagement/latticeList'], resolve),
            }, {
              path: '/remoteMonitor',
              name: 'remoteMonitor',
              meta: { title: '远程监控' },
              component: resolve => require(['../components/pages/deviceManagement/remoteMonitor'], resolve),
            },
            {
              path: '/virtual',
              name: 'virtual',
              meta: { title: '虚拟操作' },
              component: resolve => require(['../components/pages/deviceManagement/virtual'], resolve),
            }, {
              path: '/cabinetDetails',
              name: 'cabinetDetails',
              meta: { title: '柜机配置详情' },
              component: resolve => require(['../components/pages/deviceManagement/cabinetDetails'], resolve),
            },
            {
              path: '/configuration',
              name: 'configuration',
              meta: { title: '柜机配置' },
              component: resolve => require(['../components/pages/deviceManagement/configuration'], resolve),
            },
            {
              path: '/addNewProfile',
              name: 'addNewProfile',
              meta: { title: '配置' },
              component: resolve => require(['../components/pages/deviceManagement/addNewProfile'], resolve),
            }, {
              path: '/newLattice',
              name: 'newLattice',
              meta: { title: '编辑格口操作' },
              component: resolve => require(['../components/pages/deviceManagement/newLattice'], resolve),
            },
            {
              path: '/inventoryDetails',
              name: 'inventoryDetails',
              meta: { title: '库存' },
              component: resolve => require(['../components/pages/deviceManagement/inventoryDetails'], resolve),
            },
          ]
        }, {
          path: '/account',
          name: 'account',
          meta: { title: '账号管理' },
          component: resolve => require(['../components/pages/customerManage/account'], resolve),
        }, {
          path: '/newAccount',
          name: 'cabbinetAutho',
          meta: { title: '编辑账号' },
          component: resolve => require(['../components/pages/customerManage/newAccount'], resolve),
        }, {
          path: '/clerks',
          name: 'clerks',
          meta: { title: '店员列表' },
          component: resolve => require(['../components/pages/customerManage/clerks'], resolve),
        },
        {
          path: '/apply',
          name: 'apply',
          meta: { title: '店员申请列表' },
          component: resolve => require(['../components/pages/customerManage/apply'], resolve),
        }, {
          path: '/addStaff',
          name: 'addStaff',
          meta: { title: '创建角色' },
          component: resolve => require(['../components/pages/customerManage/addStaff'], resolve),
        }, {
          path: '/product',
          name: 'product',
          meta: { title: '产品管理' },
          component: resolve => require(['../components/pages/customerManage/product'], resolve),
        }, {
          path: '/newProduct',
          name: 'newProduct',
          meta: { title: '编辑产品' },
          component: resolve => require(['../components/pages/customerManage/newProduct'], resolve),
        }, {
          path: '/storeManagement',
          name: 'storeManagement',
          meta: { title: '店铺管理' },
          component: resolve => require(['../components/pages/customerManage/storeManagement'], resolve),
        }, {
          path: '/commodityGroup',
          name: 'commodityGroup',
          meta: { title: '商品分组管理' },
          component: resolve => require(['../components/pages/customerManage/commodityGroup'], resolve),
        }, {
          path: '/newcommodityGroup',
          name: 'newcommodityGroup',
          meta: { title: '新建商品分组' },
          component: resolve => require(['../components/pages/customerManage/newcommodityGroup'], resolve),
        },
        {
          path: '/rentGoods',
          name: 'rentGoods',
          meta: { title: '商品管理' },
          component: resolve => require(['../components/pages/customerManage/rentGoods'], resolve),
        },
        {
          path: '/outGoodDetail',
          name: 'outGoodDetail',
          meta: { title: '虚拟商品管理' },
          component: resolve => require(['../components/pages/customerManage/outGoodDetail'], resolve),
        },
        {
          path: '/newRentGoods',
          name: '创建套餐',
          meta: { title: '创建单品' },
          component: resolve => require(['../components/pages/customerManage/newRentGoods'], resolve),
        },
        {
          path: '/setMeal',
          name: '创建套餐',
          meta: { title: '创建套餐' },
          component: resolve => require(['../components/pages/customerManage/setMeal'], resolve),
        }, {
          path: '/storeEveryDetails',
          name: 'storeEveryDetails',
          meta: { title: '店铺详情' },
          component: resolve => require(['../components/pages/customerManage/storeEveryDetails'], resolve),
        },
        {
          path: '/skuList',
          name: 'skuList',
          meta: { title: 'SKU列表' },
          component: resolve => require(['../components/pages/customerManage/skuList'], resolve),
        },
        {
          path: '/newSku',
          name: 'newSku',
          meta: { title: '编辑SKU' },
          component: resolve => require(['../components/pages/customerManage/newSku'], resolve),
        },
        {
          path: '/skuFormList',
          name: 'skuFormList',
          meta: { title: 'SKU组成管理' },
          component: resolve => require(['../components/pages/customerManage/skuFormList'], resolve),
        },
        {
          path: '/newFormSku',
          name: 'newFormSku',
          meta: { title: 'SKU组成管理' },
          component: resolve => require(['../components/pages/customerManage/newFormSku'], resolve),
        },
        {
          path: '/skuMoneyList',
          name: 'skuMoneyList',
          meta: { title: 'SKU费用管理' },
          component: resolve => require(['../components/pages/customerManage/skuMoneyList'], resolve),
        },
        {
          path: '/newSkuMoney',
          name: 'newSkuMoney',
          meta: { title: 'SKU费用管理' },
          component: resolve => require(['../components/pages/customerManage/newSkuMoney'], resolve),
        },
        {
          path: '/skuTipsList',
          name: 'skuTipsList',
          meta: { title: 'SKU提示管理' },
          component: resolve => require(['../components/pages/customerManage/skuTipsList'], resolve),
        },
        {
          path: '/newSkuTips',
          name: 'newSkuTips',
          meta: { title: 'SKU提示编辑' },
          component: resolve => require(['../components/pages/customerManage/newSkuTips'], resolve),
        },
        {
          path: '/spuList',
          name: 'spuList',
          meta: { title: 'SPU列表' },
          component: resolve => require(['../components/pages/customerManage/spuList'], resolve),
        },
        {
          path: '/doctorList',
          name: 'doctorList',
          meta: { title: '医生列表' },
          component: resolve => require(['../components/pages/customerManage/doctorList'], resolve),
        },
        {
          path: '/newDoctor',
          name: 'newDoctor',
          meta: { title: '编辑医生' },
          component: resolve => require(['../components/pages/customerManage/newDoctor'], resolve),
        },
        {
          path: '/renterDoctor',
          name: 'renterDoctor',
          meta: { title: '导入医生' },
          component: resolve => require(['../components/pages/customerManage/renterDoctor'], resolve),
        },
        {
          path: '/newSpuData',
          name: 'newSpuData',
          meta: { title: 'SPU编辑' },
          component: resolve => require(['../components/pages/customerManage/newSpuData'], resolve),
        },
        {
          path: '/refundList',
          component: resolve => require(['../components/pages/statis/refundList'], resolve),
          meta: { title: '退款申请' }
        },
        {
          path: '/refundDetail',
          component: resolve => require(['../components/pages/statis/refundDetail'], resolve),
          meta: { title: '退款详情' }
        },
        {
          path: '/allOrder',
          component: resolve => require(['../components/pages/statis/allOrder'], resolve),
          meta: { title: '订单明细' }
        },
        {
          path: '/refundRent',
          component: resolve => require(['../components/pages/statis/refundRent'], resolve),
          meta: { title: '销售退款' }
        },
        {
          path: '/refund',
          component: resolve => require(['../components/pages/statis/refund'], resolve),
          meta: { title: '订单退款' }
        },
        {
          path: '/sameDayOrder',
          component: resolve => require(['../components/pages/statis/sameDayOrder'], resolve),
          meta: { title: '当天租赁' }
        }, {
          path: '/orderRentDetails',
          component: resolve => require(['../components/pages/statis/orderRentDetails'], resolve),
          meta: { title: '租赁订单' }
        }, {
          path: '/diversion',
          name: 'diversion',
          meta: { title: '店员导流' },
          component: resolve => require(['../components/pages/Diversion/diversion'], resolve),
        },
        {
          path: '/diversionDetails',
          name: 'diversionDetails',
          meta: { title: '导流信息' },
          component: resolve => require(['../components/pages/Diversion/diversionDetails'], resolve),
        },
        {
          path: '/storeDiversion',
          name: 'storeDiversion',
          meta: { title: '店铺导流' },
          component: resolve => require(['../components/pages/Diversion/storeDiversion'], resolve),
        },
        {
          path: '/storeDiversionDetails',
          name: 'storeDiversionDetails',
          meta: { title: '店铺导流详情' },
          component: resolve => require(['../components/pages/Diversion/storeDiversionDetails'], resolve),
        },
        {
          path: '/coupon',
          name: 'coupon',
          meta: { title: '优惠券' },
          component: resolve => require(['../components/pages/Diversion/coupon'], resolve),
        },
        {
          path: '/couponDetails',
          name: 'couponDetails',
          meta: { title: '优惠券详情' },
          component: resolve => require(['../components/pages/Diversion/couponDetails'], resolve),
        },
        {
          path: '/weChartAdmin',
          name: 'weChartAdmin',
          meta: { title: '微信公众号管理' },
          component: resolve => require(['../components/pages/Diversion/weChartAdmin'], resolve),
        },
        {
          path: '/operation',
          name: 'operation',
          meta: { title: '运营区域管理' },
          component: resolve => require(['../components/pages/Diversion/operation'], resolve),
        },
        {
          path: '/operationDetails',
          name: 'operationDetails',
          meta: { title: '运营区域管理' },
          component: resolve => require(['../components/pages/Diversion/operationDetails'], resolve),
        },
        {
          path: '/financeList',
          name: 'financeList',
          meta: { title: '财务管理' },
          component: resolve => require(['../components/pages/finance/financeList'], resolve),
        },
        {
          path: '/financeEdit',
          name: 'financeEdit',
          meta: { title: '财务管理' },
          component: resolve => require(['../components/pages/finance/financeEdit'], resolve),
        },
      ]
    }, {
      path: '/Login',
      component: resolve => require(['../components/login/Login.vue'], resolve)
    },
  ]
});





// WEBPACK FOOTER //
// ./src/router/index.js